import { render, staticRenderFns } from "./Services_change.vue?vue&type=template&id=7d00c42f&"
import script from "./Services_change.vue?vue&type=script&lang=js&"
export * from "./Services_change.vue?vue&type=script&lang=js&"
import style0 from "./Services_change.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports